import { useState, useContext } from "react";
import classes from "@styles/community/contactTab.module.css";
import { Facebook, Instagram, Phone, YouTube, ModeEditOutlineOutlined as Edit } from "@mui/icons-material";
import { Store } from "@store";
import { updateCommunity } from "queries/community.queries";
import Link from "next/link";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
import { useRouter } from "next/router";
export default function ContactTab({
  communityDetail,
  isAdmin,
  communityID,
  typeID,
  ownerUid
}) {
  const router = useRouter();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [fbEditable, setFbEditable] = useState(false);
  const [facebook, setFacebook] = useState(communityDetail?.facebook || "");
  const [igEditable, setIgEditable] = useState(false);
  const [instagram, setInstagram] = useState(communityDetail?.instagram || "");
  const [ytEditable, setYtEditable] = useState(false);
  const [youtube, setYouTube] = useState(communityDetail?.youtube || "");
  const [websiteEditable, setWebsiteEditable] = useState(false);
  const [website, setWebsite] = useState(communityDetail?.website || "");
  const [contactEditable, setContactEditable] = useState(false);
  const [contact, setContact] = useState(communityDetail?.contact || "");
  const [saveBtn, setSaveBtn] = useState(false);
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  function editHandler(type) {
    switch (type) {
      case "Facebook":
        setFbEditable(true);
        break;
      case "Instagram":
        setIgEditable(true);
        break;
      case "YouTube":
        setYtEditable(true);
        break;
      case "Website":
        setWebsiteEditable(true);
        break;
      case "Contact":
        setContactEditable(true);
        break;
      default:
        return () => {};
    }
    setSaveBtn(true);
  }
  async function onSaveHandler() {
    if (fbEditable) setFbEditable(false);
    if (igEditable) setIgEditable(false);
    if (ytEditable) setYtEditable(false);
    if (websiteEditable) setWebsiteEditable(false);
    if (contactEditable) setContactEditable(false);
    const obj = {
      communityID: communityID,
      ownerUid: ownerUid,
      typeID: typeID,
      CommunityDetail: {
        facebook: facebook,
        instagram: instagram,
        youtube: youtube,
        website: website,
        contact: contact
      },
      CommunityAddress: {}
    };
    const res = await updateCommunity({
      data: obj,
      accessToken: loggedInUser.accessToken
    });
    if (res) {
      // swal.fire({
      //   title: "Your Contact Details have been updated !",
      //   icon: "success",
      //   background: "#f2f2f2",
      //   backdrop: "rgba(34, 34, 34, 0.4);",
      //   customClass: {
      //     title: `${modalClasses.modalCard__heading}`,
      //     htmlContainer: `${modalClasses.modalCard__msg}`,
      //     actions: `${modalClasses.modalCard__options} `,
      //     cancelButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_neg}`,
      //     confirmButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_pos}`,
      //   },
      // });
      setErrorModal({
        open: true,
        heading: "Success",
        message: "Your Contact Details have been updated !",
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <CheckCircleOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "green"
        }} />,
        positive: true
      });
    } else {
      alert("Something went wrong!");
    }
    setSaveBtn(false);
  }
  function validateURL(link) {
    if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
      return link;
    } else {
      return "http://" + link;
    }
  }
  return <div className={`${classes.contactTab}`} data-sentry-component="ContactTab" data-sentry-source-file="ContactTab.jsx">
      <h2 className={`${classes.heading_h2}`}>Bio</h2>
      <p className={`${classes.bio_p}`}>{communityDetail?.description}</p>
      <h2 className={`${classes.heading_h2}`}>Contact</h2>
      <div className={`${classes.contactMenu}`}>
        {isAdmin ? <div className={`${classes.socials}`}>
            <Facebook fontSize="large" />
            <div className={`${classes.contactMenu_input}`}>
              <input type="text" id="facebook" disabled={!fbEditable} value={facebook} onChange={e => setFacebook(e.target.value)} placeholder="Enter Facebook Link" className={`${classes.contact_input}`} />
            </div>
            <Edit onClick={() => editHandler("Facebook")} />
          </div> : <>
            {communityDetail?.facebook && <div className={`${classes.socials}`}>
                <Facebook fontSize="large" />
                <div className={`${classes.social_p}`}>
                  <Link target="_blank" rel="noreferrer alternate" href={validateURL(communityDetail?.facebook)} hrefLang={router.locale}>
                    {communityDetail?.facebook}
                  </Link>
                </div>
              </div>}
          </>}

        {isAdmin ? <div className={`${classes.socials}`}>
            <Instagram fontSize="large" />
            <div className={`${classes.contactMenu_input}`}>
              <input type="text" id="instagram" disabled={!igEditable} value={instagram} onChange={e => setInstagram(e.target.value)} placeholder="Enter Instagram Link" className={`${classes.contact_input}`} />
            </div>
            <Edit onClick={() => editHandler("Instagram")} />
          </div> : <>
            {communityDetail?.instagram && <div className={`${classes.socials}`}>
                <Instagram fontSize="large" />
                <div className={`${classes.social_p}`}>
                  <Link target="_blank" rel="noreferrer alternate" href={validateURL(communityDetail?.instagram)} hrefLang={router.locale}>
                    {communityDetail?.instagram}
                  </Link>
                </div>
              </div>}
          </>}

        {isAdmin ? <div className={`${classes.socials}`}>
            <YouTube fontSize="large" />
            <div className={`${classes.contactMenu_input}`}>
              <input type="text" id="youtube" disabled={!ytEditable} value={youtube} onChange={e => setYouTube(e.target.value)} placeholder="Enter YouTube Link" className={`${classes.contact_input}`} />
            </div>
            <Edit onClick={() => editHandler("YouTube")} />
          </div> : <>
            {communityDetail?.youtube && <div className={`${classes.socials}`}>
                <YouTube fontSize="large" />
                <div className={`${classes.social_p}`}>
                  <Link target="_blank" rel="noreferrer alternate" href={validateURL(communityDetail?.youtube)} hrefLang={router.locale}>
                    {communityDetail?.youtube}
                  </Link>
                </div>
              </div>}
          </>}

        {isAdmin ? <div className={`${classes.socials}`}>
            <a fontSize="large" />
            <div className={`${classes.contactMenu_input}`}>
              <input type="text" id="website" disabled={!websiteEditable} value={website} onChange={e => setWebsite(e.target.value)} placeholder="Enter Website Link" className={`${classes.contact_input}`} />
            </div>
            <Edit onClick={() => editHandler("Website")} />
          </div> : <>
            {communityDetail?.website && <div className={`${classes.socials}`}>
                <a fontSize="large" />
                <div className={`${classes.social_p}`}>
                  <Link target="_blank" rel="noreferrer alternate" href={validateURL(communityDetail?.website)} hrefLang={router.locale}>
                    {communityDetail?.website}
                  </Link>
                </div>
              </div>}
          </>}

        {isAdmin ? <div className={`${classes.socials}`}>
            <Phone fontSize="large" />
            <div className={`${classes.contactMenu_input}`}>
              <input type="tel" id="mobile" disabled={!contactEditable} value={contact} onChange={e => setContact(e.target.value)} placeholder="Enter Mobile Number" className={`${classes.contact_input}`} />
            </div>
            <Edit onClick={() => editHandler("Contact")} />
          </div> : <>
            {communityDetail?.contact && <div className={`${classes.socials}`}>
                <Phone fontSize="large" />
                <div className={`${classes.social_p}`}>
                  <Link href={`tel:${communityDetail?.contact}`} rel="alternate" hrefLang={router.locale}>
                    {communityDetail?.contact}
                  </Link>
                </div>
              </div>}
          </>}
        {saveBtn ? <div className={`${classes.btn_div}`}>
            <button type="submit" className={`${classes.btn_save} ${classes.btn}`} onClick={onSaveHandler}>
              Save
            </button>
          </div> : null}
      </div>
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg="Okay" onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </div>;
}